<div class="survey-list-item item" (click)="onSelect()">
    <div class="heading">
        <div class="title">
            {{ job.name }}
        </div>
        <div class="badge-and-visibility">
            <job-status-badge [status]="job.status"></job-status-badge>
            <div class="visibility-icon" (click)="onVisibilityToggle($event)" title="{{ (job.visible ? 'TC.Common.Hide' : 'TC.Common.Show') | translate }}">
                <i
                    class="i24 clickable"
                    [ngClass]="{
                        icon_line_visibility_show: job.visible,
                        icon_line_visibility_hide: !job.visible
                    }"
                ></i>
            </div>
        </div>
    </div>

    <div class="content">
        <div class="user-and-updated-details">
            <div class="created-by">
                <span class="label">{{ 'TC.Common.CreatedBy' | translate }} </span>
                <span class="value">{{ job.createdBy.name }} on {{ job.createdDateTime | date: 'mediumDate' }}</span>
            </div>
            <div class="assigned-by">
                <span class="label">{{ 'TC.Common.AssignedUser' | translate }} </span>
                <span class="value">
                    {{
                        job.assignees && job.assignees.length > 0
                            ? job.assignees[job.assignees.length - 1].name
                            : ('TC.Common.NotApplicableSymbol' | translate)
                    }}
                </span>
            </div>
            <div class="updated">
                <span class="label">{{ 'TC.Common.LastUpdated' | translate }} </span>
                <span class="value">{{ job.modifiedDateTime | date: 'mediumDate' }}</span>
            </div>
            <div class="tags" *ngIf="jobTags.length">
              <job-file-tag-chips
                  [files]="jobTags"
                  [chipType]="JobAttachmentChipType.Tag"
                  [inlineMode]="true"
                  [disableRipple]="true"
                  (click)="disableClick($event)"
                   />
            </div>
        </div>

        <div class="tools">
            <i
                class="modus-icons download-icon"
                [class.disabled]="isDownloading"
                (click)="onDownload($event)"
                [title]="'TCW_Download' | translate"
                >download_line</i
            >
        </div>
    </div>
</div>
